
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

interface CollapsibleFiltersProps {
  children: React.ReactNode;
}

export const CollapsibleFilters = ({ children }: CollapsibleFiltersProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="w-full"
    >
      <CollapsibleContent className="pt-4">
        {children}
      </CollapsibleContent>

      <CollapsibleTrigger asChild>
        <Button 
          variant="outline" 
          className="w-full mt-2 border-dashed" 
          aria-label={isOpen ? "Skjul flere filtre" : "Vis alle filtre"}
        >
          <ChevronDown className={`h-4 w-4 mr-2 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} />
          {isOpen ? "Vis mindre" : "Alle filtre"}
        </Button>
      </CollapsibleTrigger>
    </Collapsible>
  );
};
